import { render, staticRenderFns } from "./TDOverview.vue?vue&type=template&id=4ab1fe09&scoped=true"
import script from "./TDOverview.vue?vue&type=script&lang=js"
export * from "./TDOverview.vue?vue&type=script&lang=js"
import style0 from "./TDOverview.vue?vue&type=style&index=0&id=4ab1fe09&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ab1fe09",
  null
  
)

export default component.exports